// import WorkingGirl from "../componenets/animation/workingGirl";
// import { techstackWlogo } from "./constants";

// export default function TechStack() {
//   return (
//     <div className="text-black mt-30">
//       <h2
//         className="text-3xl font-semibold mb-10 mt-11 dark:text-black text-black"
//         id="skills"
//       >
//         Skills
//       </h2>

//       <div className="m-6 flex flex-col md:flex-row items-center justify-center gap-10">
//         {/* Working Girl Animation */}
//         <div className="w-full md:w-1/2 order-2 md:order-none flex justify-center">
//           <WorkingGirl />
//         </div>

//         {/* Tech Stack Cards */}
//         <div className="w-full md:w-1/2 order-1 md:order-none">
//           <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6 text-center">
//             {techstackWlogo.map((item) => (
//               <div
//                 key={item.label}
//                 className="group relative bg-white dark:bg-neutral-100 shadow-sm rounded-xl p-4 flex flex-col items-center transition-all duration-300 hover:shadow-lg hover:scale-105"
//               >
//                 <span className="text-4xl text-primary mb-2">{item.icon}</span>
//                 <p className="text-sm font-semibold">{item.label}</p>

//                 {/* Hover overlay with depth */}
//                 <div className="absolute top-0 left-0 w-full h-full bg-white dark:bg-neutral-200 bg-opacity-95 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-xl p-4 flex flex-col items-center justify-center z-10 text-center">
//                   <p className="text-xs text-gray-800 font-semibold mb-1">
//                     {item.experience}
//                   </p>
//                   <p className="text-[11px] text-gray-600 font-mono">
//                     {item.usage}
//                   </p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// import React, { useState } from "react";
// import WorkingGirl from "../componenets/animation/workingGirl";
// import { techstackWlogo } from "./constants";

// const categories = ["All", "Frontend", "Backend", "DevOps", "Tools"];

// export default function TechStack() {
//   const [activeCategory, setActiveCategory] = useState("All");

//   const filteredStack =
//     activeCategory === "All"
//       ? techstackWlogo
//       : techstackWlogo.filter((item) => item.category === activeCategory);

//   return (
//     <div className="text-black mt-30">
//       <h2
//         className="text-3xl font-semibold mb-10 mt-11 dark:text-black text-black"
//         id="skills"
//       >
//         Skills
//       </h2>

//       {/* Filter Buttons */}
//       <div className="flex flex-wrap justify-center gap-4 mb-8">
//         {categories.map((cat) => (
//           <button
//             key={cat}
//             onClick={() => setActiveCategory(cat)}
//             className={`px-4 py-2 rounded-full border text-sm font-medium transition ${
//               activeCategory === cat
//                 ? "bg-primary text-white"
//                 : "bg-white text-black border-black hover:bg-primary hover:text-white"
//             }`}
//           >
//             {cat}
//           </button>
//         ))}
//       </div>

//       <div className="m-6 flex flex-col md:flex-row items-center justify-center gap-10">
//         {/* Animation */}
//         <div className="w-full md:w-1/2 order-2 md:order-none flex justify-center">
//           <WorkingGirl />
//         </div>

//         {/* Filtered Grid */}
//         <div className="w-full md:w-1/2 order-1 md:order-none">
//           <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6 text-center">
//             {filteredStack.map((item) => (
//               <div
//                 key={item.label}
//                 className="group relative bg-white shadow-sm rounded-xl p-4 flex flex-col items-center transition-all duration-300 hover:shadow-lg hover:scale-105"
//               >
//                 <span className="text-4xl text-primary mb-2">{item.icon}</span>
//                 <p className="text-sm font-semibold">{item.label}</p>

//                 {/* Hover Info */}
//                 <div className="absolute top-0 left-0 w-full h-full bg-white bg-opacity-95 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-xl p-4 flex flex-col items-center justify-center z-10 text-center">
//                   <p className="text-xs text-gray-800 font-semibold mb-1">
//                     {item.experience}
//                   </p>
//                   <p className="text-[11px] text-gray-600 font-mono">
//                     {item.usage}
//                   </p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

import { motion } from 'framer-motion';
import WorkingGirl from '../componenets/animation/workingGirl';
import { techstackWlogo } from './constants';
import { useState } from 'react';
import CustomFilterButton from './commonComp/customFilterButton';

const categories = [
  'All',
  'Frontend',
  'Backend & APIs',
  'Cloud & DevOps',
  'Tools',
  'Collaboration',
];

export default function TechStack() {
  const [activeCategory, setActiveCategory] = useState('All');

  const filteredStack =
    activeCategory === 'All'
      ? techstackWlogo
      : techstackWlogo.filter((item) => item.category === activeCategory);

  return (
    <div className="text-black mt-30" id="skills">
      <h2
        className="text-3xl font-bold mb-2 text-center dark:text-white text-black"
        id="skills"
      >
        🛠️ Skills
      </h2>
      <p className="text-center text-sm text-gray-600 dark:text-gray-400 mb-8 max-w-2xl mx-auto">
        I enjoy building full-stack products with clean, scalable code —
        especially on the frontend.
      </p>

      {/* Filter Buttons */}
      <div className="flex flex-wrap justify-center gap-4 mb-8">
        {categories.map((cat) => (
          // <button
          //   key={cat}
          //   onClick={() => setActiveCategory(cat)}
          //   className={`px-4 py-2 rounded-full border text-sm font-medium transition ${
          //     activeCategory === cat
          //       ? "bg-primary text-white"
          //       : "bg-white text-black border-black hover:bg-primary hover:text-white"
          //   }`}
          // >
          //   {cat}
          // </button>
          <CustomFilterButton
            setActiveCategory={setActiveCategory}
            cat={cat}
            activeCategory={activeCategory}
          >
            {cat}
          </CustomFilterButton>
        ))}
      </div>

      <div className="m-6 flex flex-col md:flex-row items-center justify-center gap-10">
        {/* Animation */}
        <div className="w-full md:w-1/2 order-2 md:order-none flex justify-center">
          <div>
            <WorkingGirl />
            <p className="text-sm italic text-center text-gray-500 mb-6 dark:text-white">
              I focus on tools that help me ship faster, write cleaner code, and
              build better experiences.
            </p>
          </div>
        </div>

        {/* Skill Cards Grid */}
        <div className="w-full md:w-1/2 order-1 md:order-none">
          <div className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-4 gap-6 content-center ">
            {filteredStack.map((item, index) => (
              // <motion.div
              //   key={item.label}
              //   className="group relative  dark:bg-neutral-900 shadow-sm dark:shadow-gray-700 rounded-xl p-4 flex flex-col items-center transition-all duration-300 hover:shadow-lg hover:scale-105"
              //   // initial={{ opacity: 0, y: 40 }}
              //   // whileInView={{ opacity: 1, y: 0 }}
              //   // transition={{ duration: 0.4, delay: index * 0.05 }}
              //   // viewport={{ once: true }}
              // >
              <div className="flex flex-col items-center">
                <span className="text-4xl text-primary dark:text-primary-light mb-2 items-center">
                  {item.icon}
                </span>
                <p className="text-sm font-semibold text-primary dark:text-gray-100 items-center">
                  {item.label}
                </p>

                {/* <div className="absolute top-0 left-0 w-full h-full bg-black bg-opacity-70 backdrop-blur-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-xl p-4 flex flex-col items-center justify-center z-10 text-center">
                  <p className="text-xs text-gray-200 font-semibold mb-1">
                    {item.experience}
                  </p>
                  <p className="text-[11px] text-gray-300 font-mono">
                    {item.usage}
                  </p>
                </div> */}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
